/**
 * Portal icons mapping
 * Maps portal names to their corresponding icon filenames
 */
export const iconByPortal: Record<string, string> = {
  'homegate.ch': 'homegate.ico',
  'immoscout24.ch': 'immoscout24.ico',
  Comparis: 'comparis.ico',
  'newhome.ch': 'newhome.ico',
  Anibis: 'anibis.ico',
  Tutti: 'tutti.ico',
  BuyRent: 'buyrent.ico',
  iCasa: 'icasa.ico',
  Properstar: 'properstar.ico',
  ProperstarIdx: 'properstar.ico',
  Flatfox: 'flatfox.png',
  'betterhomes.ch': 'betterhomes.ico',
  'UrbanHome.ch': 'urbanhome.ico',
  Dreamo: 'dreamo.ico',
  'immogalaxy.ch': 'immogalaxy.ico',
  NZZDomizil: 'nzzdomizil.png',
  JustLanded: 'justlanded.ico',
  'Neubau Portal AG': 'neubauprojekte.png',
  Publiaz: 'publiaz.png',
  'Propylaia GmbH': 'smart-propylaia.png',
  'Immobilier.ch': 'immobilier_ch.png',
  Properti: 'properti.webp',
  immoving: 'justimmo.ico',
  MaisonWorkIdx: 'maison.work.png',
  Neho: 'neho.png',
  SherlockHomesIdx: 'sherlockhomes.png',
}
